import React from 'react';
import { execIncentiveStatus } from './marketingOrdersView';

const formatINR = (val?: number) => '₹' + Number(val || 0).toLocaleString('en-IN');

interface Props {
  pendingOrders: number;
  pendingAmount: number;
  creditedOrders: number;
  creditedAmount: number;
}

/** The Status cell of the marketing and farm executive tables. */
const ExecIncentiveStatusCell: React.FC<Props> = ({
  pendingOrders, pendingAmount, creditedOrders, creditedAmount,
}) => {
  const status = execIncentiveStatus({ pendingOrders, creditedOrders });
  if (status === 'NONE') return <span className="text-slate-300">—</span>;
  if (status === 'CREDITED') {
    return (
      <div className="flex flex-col gap-0.5 whitespace-nowrap">
        <span className="inline-flex self-start px-2 py-0.5 rounded-lg bg-emerald-50 text-emerald-700 border border-emerald-200 text-[10px] font-bold uppercase tracking-wide">
          Credited
        </span>
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-0.5 whitespace-nowrap">
      <span className="inline-flex self-start px-2 py-0.5 rounded-lg bg-amber-50 text-amber-700 border border-amber-200 text-[10px] font-bold uppercase tracking-wide">
        Pending approval
      </span>
    </div>
  );
};

export default ExecIncentiveStatusCell;
